import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { LayoutProvider, useLayout } from '../../context/LayoutContext';

const LayoutContent: React.FC = () => {
  const { sidebarOpen, setSidebarOpen, isMobile } = useLayout();

  return (
    <div className="min-h-screen bg-secondary-50">
      <Header />
      
      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      
      <div className="flex">
        <Sidebar />
        <main className={`
          flex-1 p-2 pt-20 transition-all duration-300 ease-in-out min-h-[calc(100vh-4rem)]
          ${isMobile ? 'ml-0' : 'lg:ml-56'}
          ${isMobile && sidebarOpen ? 'ml-56' : ''}
        `}>
          <div className="max-w-full overflow-x-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

const Layout: React.FC = () => {
  return (
    <LayoutProvider>
      <LayoutContent />
    </LayoutProvider>
  );
};

export default Layout;